import React from 'react'

import { object, shape, string } from 'prop-types'

import rocketIcon from 'images/discover/datasets/rocket.svg'

import { FORM_ANCHOR_ID } from '../../constants'
import Label from '../Label/Label'
import LeadForm from '../LeadForm/LeadForm'

function Cta({ cta, form }) {
  return (
    <section id={FORM_ANCHOR_ID} className="datasets-cta discover-anchor">
      <div className="discover-container">
        <div className="datasets-cta__wrap">
          <div className="datasets-cta__content">
            <Label icon={rocketIcon} text={cta.label} isDark />
            <h2 className="datasets-cta__title cgt-heading-500">{cta.title}</h2>
            <p className="datasets-cta__text cgt-body-lg">{cta.text}</p>
          </div>
          <LeadForm form={form} />
        </div>
      </div>
    </section>
  )
}

Cta.propTypes = {
  cta: shape({
    label: string.isRequired,
    title: string.isRequired,
    text: string.isRequired,
  }).isRequired,
  form: object.isRequired,
}

export default Cta
